module.exports = {
    亚马逊: 'Amazon',
    沃尔玛: 'Walmart',
    星巴克: 'Starbucks',
    苹果卡: 'Apple',
    PayPal: 'Paypal',
    success: 'éxito',
    综合评价: "Evaluación General",
    inputNotSame: "Entrada No Igual",
    example: 'Ejemplo',
    // 选择语言
    popupTitle: 'Seleccionar idioma',
    // 发送
    send: 'Confirmar',
    // 发送邮件
    sendEmail: 'Enviar correo electrónico',
    // 改变语言
    changeLanSes: 'Cambio de idioma exitoso',
    // 中文
    chinese: '中文',
    // 法语
    french: 'Francais',
    // 英语
    english: 'English',
    // 德语
    german: 'Deutsch',
    // 西班牙语
    spanish: 'Espaiol',
    // 意大利语
    italian: 'Italiano',
    // 系统标题
    title: 'La voz del comprador',
    // 系统解释
    details: 'Escuchar la voz de los compradores, ofrecer productos y servicios de calidad, gracias por compartir.',
    fileSizeOver: "El archivo es demasiado grande, solo se admiten imágenes de hasta 10 MB.",
    lowTextarea: 'Sus comentarios nos ayudarán a mejorar continuamente nuestros productos y servicios.',
    placeholderOrderNo: "Introduzca el número de pedido (formato: 000-0000000-0000000)",
    "picUploadSuccessText": "Imagen subida con éxito",
    "picUploadErrorText": "Error al subir la imagen",
    "orderNotExistText": "El pedido no existe",
    "orderInvalidText": "Este pedido es inválido",
    "networkErrorText": "Error de red",
    "orderErrorText": "Error en el pedido",
    // step1
    formBasic: {
        title: `Registre su garantía ahora
Reclame su caja <span style="color:#F40000">misteriosa</span>, oferta exclusiva para clientes actuales.`,
        form_name: 'Nombre',
        form_email: 'Correo electrónico',
        form_order: 'ID de pedido',
        form_order_error_placeholder: "Introduzca el número de pedido (formato: 000-0000000-0000000)",
        order_why: '*¿Cómo encontrar su número de pedido?',
        order_answer: '*No compartimos su información personal con nadie.Su información personal está segura y se utiliza únicamente para la activación de la garantía.',
        btn_text: 'Activar ahora',
        "form_name_placeholder": "Por favor ingresa tu nombre",
        "form_email_placeholder": "Por favor ingresa tu correo electrónico",
        "form_email_error_placeholder": "Por favor ingresa un correo electrónico válido",
        "form_order_placeholder": "Por favor ingresa tu número de pedido"
    },
    // step2
    showGiftCard: {
        title: `¡Felicidades!</br>
¡Tu garantía ha sido activada!`,
        text: `Comparte tu experiencia de compra y recibe una Caja <span style="color:#F40000">Misteriosa</span>. (Aproximadamente 1 minuto)`,
        gift_card_text: 'Lo que puedes obtener',
        btn_text: 'Siguiente paso'
    },
    // step3
    star: {
        title: '¿Estás satisfecho con este producto o nuestro servicio?',
        text: 'Por favor, califica el producto con estrellas a continuación:',
        star__placeholder: '¡Por favor califique todas las preguntas antes de enviarlas!',
        written: 'Añadir una reseña escrita: <span style="color:#F40000">(Opcional)</span>',
        written_placeholder: '¿Qué te gustó? ¿Para qué usaste este producto?',
        btn_text: 'Siguiente paso'
    },
    // step4
    ensureEmail: {
        title: `Enhorabuena!</br>
Has terminado la encuesta.
`,
        text: `Por favor, confirme la dirección de correo electrónico, recibirá el código de regalo a través de esta dirección de correo electrónico:
redeem@amazonsurveyzone.com`,
        email_placeholder: "¡Por favor confirma nuevamente el correo electrónico!",
        btn_text: 'Confirmar'
    },
    // step5
    channelSelect: {
        title: `¡Tu opinión importa! `,
        text: `Comparte tus opiniones sobre productos en Amazon para ayudar a otros clientes a tomar decisiones correctas.
Únete ahora a la comunidad de opiniones y gana recompensas extra.`,
        footer: `*Sobre el regalo:</br>
Sin gastos de envío,Sin cargos ocultos,No requiere tarjeta de crédito`,
        btn_text: 'Lo quiero'
    },
    // step6
    uploadPic: {
        title: `Por favor, suba la captura de pantalla de su reseña en Amazon después de escribirla`,
        text: `Una vez que su reseña se haya publicado correctamente en Amazon, nos pondremos en contacto con usted por correo electrónico:
redeem@amazonsurveyzone.com y le enviaremos la Caja Misteriosa.`,
        add_pic: 'Añadir fotos',
        add_pic_text: 'Normalmente Amazon tardará 2-3 días en revisar.',
        btn_text: 'Siguiente paso'
    },
    // step7
    cityForm: {
        title: '*Dirección de recepción de accesorios: ',
        text: '(Plz confirmar su dirección de envío, el regalo será arreglado en 3-5 días laborables).',
        form_city: 'Ciudad',
        form_state: 'Estado/Región',
        form_postal_code: 'Código postal',
        form_country: 'País',
        btn_text: 'Confirme',
        "form_city_placeholder": "Por favor ingresa tu ciudad",
        "form_state_placeholder": "Por favor ingresa tu área",
        "form_postal_code_placeholder": "Por favor ingresa tu código postal",
        "form_country_placeholder": "Por favor ingresa tu país"
    },
    // step7
    paypalForm: {
        title: '*Cuenta de recepción de la tarjeta regalo:',
        text: '(Por favor, compruebe cuidadosamente la información de su cuenta)',
        form_paypal: 'Cuenta Paypal',
        form_ensure_paypal: 'Confirme dos veces la cuenta Paypal',
        form_paypal_name: 'Nomb',
        btn_text: 'Confirme',
        "form_paypal_placeholder": "Por favor ingresa tu cuenta PayPal",
        "form_ensure_paypal_placeholder": "Por favor confirma tu cuenta PayPal",
        "form_paypal_name_placeholder": "Por favor ingresa tu nombre PayPal"

    },
    // thanks-all
    thanksAll: {
        "title": "¡Agradecidos por tu contribución!",
        // title_desc1: 'Gracias por participar en nuestra encuesta sobre productos.',
        // title_desc2: 'projector survey!',
        text: `Sus valiosas opiniones nos ayudarán a mejorar la calidad del producto. 
Si tiene alguna pregunta durante el uso, no dude en ponerse en contacto con nosotros.`
    },
    // thanks
    thanks: {
        "title1": "¡Felicidades!",
        title_desc1: `Su garantía está activada.
Muchas gracias por su tiempo.`,
        title_default_paypal_desc1: `Su garantía está activada.
Muchas gracias por su tiempo. Tu recompensa se emitirá en un plazo de 24 a 72 horas.`, 
        // title_desc2: 'Thank you very much for your time.',
    },
    // flow
    flow: {
        step1: 'Click to your homepage and click your orders',
        step2: 'Find the order of our store and click it',
        step3: 'Find the page of “Order info” and click “View order details”',
        step4: 'Order # is your order number, and you can copy the number and fill in our website',
    }
}
